import React from 'react';
import { withStyles } from "@mui/styles";
import {avgColors, colorGridNoHoverStyles, colorMid, getColorRGB, toRGBA} from "./colorUtils";

const styles = {
  ...colorGridNoHoverStyles,
  tableWrapper:{
    border: "1px solid rgba(0,0,0,0.12)",
    borderRadius: "4px",
    overflow: "hidden"
  },
  table:{
    width: "100%",
    textAlign: "left",
    // borderCollapse: "collapse",
    borderSpacing: 0,
    backgroundColor: "#fafafa",
    display: "block",
    maxHeight: "calc(min(70vh, max(22rem, 35vh)))",
    overflow: "auto",
    '& tbody':{
    },
    '& tbody tr:first-child td':{
      borderTop: 0
    },
    '& thead':{
    }
  },
  thead:{
    fontWeight: 600,
    backgroundColor: "#fafafa",
    position: "sticky",
    outline: "1px solid rgba(0,0,0,0.12)",
    top: 0,
    '& td':{
      padding: "0.25rem 0.5rem"
    }
  },
  tbody:{
    // maxHeight: "calc(min(75vh, max(22rem, 50vh)))",
    overflow:"auto"
  },
  hover: {
    '&:hover':{
      backgroundColor: "rgb(253,253,253)",
    }
  },
  row:{
    padding: "0.5rem",
    verticalAlign: "top",
    '& > td': {
      border: "1px solid rgba(0,0,0,0.12)",
      borderBottom: 0,
      borderRight: 0,
      paddingRight: "0.25rem",
    },
    '& > td:first-child': {
      borderLeft: 0,
      padding: "0.25rem 0.5rem",
    },
    '& > td:nth-child(2)': {
      padding: "0.25rem",
    }
  },
  number:{
    fontWeight: 600,
    cursor: "pointer",
  },
  statement:{
    width: "100%",
    textDecoration: "underline",
    cursor: "pointer",
  },
  numberCell: {
    fontWeight: 600,
    textAlign: "center",
    borderRight: "0 !important",
    paddingBottom: "0 !important",
  },
  answerCell: {
    borderLeft: "0 !important",
    paddingLeft: "0 !important",
    textAlign: "top !important",
  },
  answerLabel: {
    minWidth: "min-content",
    width: "calc(35vw - 4.75rem)",
    display: "block",
    boxSizing: "border-box",
    maxWidth: "max-content",
    margin: "0 auto",
    overflow: "hidden",
    textAlign: "center",
  },
  answerLabelSmall: {
    width: "calc(18vw - 5.05rem)",
    minWidth: 0,
  },
};

const getCombinedBorderColor = (values, options) => {
  if(options.length <= 1 || values.length <= 1){
    return null;
  }
  const likelyCol = getColorRGB(options.choices[0].color_class, values[0] - 1);
  const impactCol = getColorRGB(options.choices[1].color_class, values[1] - 1);
  return avgColors(impactCol, likelyCol);
}

function AnswerTable({surveyAttempt: {survey: {questions, options}, answers}, jumpToQuestion, classes}){
  const mid = options.choices.map(opt => Math.floor(opt.answers.length/2));
  // const count = options.choices.map(opt => opt.answers.length);
  const even = options.choices.map(opt => opt.answers.length % 2 === 0);

  return <div className={classes.tableWrapper}>
    <table className={classes.table}>
      <thead className={classes.thead}>
        <tr>
          <td colSpan={2}>Question</td>
          <td colSpan={options.choices.length*2}>Answer</td>
        </tr>
      </thead>
      <tbody className={classes.tbody}>
      {answers.map(([qId, values=[], answerDate, comment, commentDate], i) => {
        const borderColor = getCombinedBorderColor(values, options);
        const borderStyle = !!borderColor ? {paddingTop: "calc(0.25rem - 2px)", border: "1px solid rgba(0,0,0,0.52) !important", borderLeftWidth: "1px", borderLeftColor: toRGBA(borderColor, 1)} : null;

        return <tr className={`${classes.row} ${classes.hover}`}  key={i}>
          <td className={classes.number} onClick={() => jumpToQuestion(i)}>
            {/*eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
            <a onClick={() => jumpToQuestion(i)}>{i+1}</a>
          </td>
          <td className={classes.statement} onClick={() => jumpToQuestion(i)}>
            {/*eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
            <a onClick={() => jumpToQuestion(i)}>{questions[qId]?.statement}</a>
          </td>
          {values.map((value, v) => {
            const colorClass = options.choices[v].color_class;
            const val = value - 1;
            const adjustedVal = (val - mid[v]) + ((val >= mid[v] && even[v]) ? 1 : 0)
            const colI = Math.round((adjustedVal / mid[v]) * colorMid) + colorMid;
            const className = classes[`${colorClass}N${colI}`];
            const numberBorder = !borderStyle ? {padding: "0.25rem"} : v === 0 ? {...borderStyle, borderLeftWidth: "1rem"} : {...borderStyle, borderLeftWidth: "0", paddingLeft: "0.25em" };
            const answerBorder = !borderStyle ? {padding: "0.25rem"} : v === 0 ? {...borderStyle, borderRight: "1px"} : borderStyle;

            return [
              <td key={`${v}_0`}
                className={className + " " + classes.numberCell}
                style={numberBorder}
              >
                {adjustedVal > 0 ? "+" : null}{adjustedVal}
              </td>,
              <td key={`${v}_1`}
                className={className + " " + classes.answerCell}
                style={answerBorder}
              >
                <div className={`${classes.answerLabel} ${options.choices.length <= 1 ? "" : classes.answerLabelSmall}`}>
                  {options.choices[v].answers[val]?.label || "Unknown"}
                </div>
              </td>
            ]
          }).flat()}
        </tr>
      })}
      </tbody>
    </table>
  </div>
}

export default withStyles(styles)(AnswerTable)
